module.exports = __webpack_public_path__ + "img/tl-b.74ceefe6.jpg";